import { useEffect, useState } from 'react';
import { useProductForm } from './useForms';


export const useProductInSupplierForm = (productId) => {
  const initialProductValues = useProductForm(productId, null, null)
  let productRelatedInitialSupplierValues: any = {}
  //console.log("Initial Product Values", initialProductValues, productId)
  
  if (initialProductValues != null) {
    productRelatedInitialSupplierValues.Product = initialProductValues?.ProductId
    productRelatedInitialSupplierValues.Manufacturer = initialProductValues?.Manufacturer
    productRelatedInitialSupplierValues.ManufacturerProduct = initialProductValues?.ManufacturerProductId
    productRelatedInitialSupplierValues.ManufacturerProduct_Value = initialProductValues?.ManufacturerProductName
    productRelatedInitialSupplierValues.ProductType = initialProductValues?.ProductType_Value ?? initialProductValues?.ProductType
    productRelatedInitialSupplierValues.TARIC = initialProductValues?.TARIC
    productRelatedInitialSupplierValues.EAN = initialProductValues?.EAN
    productRelatedInitialSupplierValues.ProductStatus = initialProductValues?.ProductStatus_Key
    productRelatedInitialSupplierValues.CountryOfOrigin = initialProductValues?.CountryOfOrigin_Value
  }
  //console.log("Product Related Initial Supplier Values", productRelatedInitialSupplierValues, initialProductValues)
  return productRelatedInitialSupplierValues;
}


export function useSelectProductInForm() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductSelector, setShowProductSelector] = useState(-1);
  return {
      selectedProduct,
      setSelectedProduct,
      showProductSelector,
      setShowProductSelector
  };
}

export function useUpdateFormikWithSelectedProduct(values, setFieldValue, selectedProduct) {
  useEffect(() => {
      if (selectedProduct) {
        //  console.log("Selected product", selectedProduct);
          setFieldValue("Product", selectedProduct?.ProductId || "");
          setFieldValue("Manufacturer", selectedProduct?.Manufacturer?.Key || "");
          setFieldValue("ManufacturerProduct", selectedProduct?.ManufacturerProductId || "");
          setFieldValue("ManufacturerProduct_Value", selectedProduct?.ManufacturerProduct?.Value || "");
          setFieldValue("ProductType", selectedProduct?.ProductType?.Value || "");
          setFieldValue("ProductStatus", selectedProduct?.ProductStatus?.Key || "");
      }
  }, [selectedProduct]);
}